module.exports = __webpack_public_path__ + "img/brand-2.057eeaf9.jpg";